import { z } from 'zod';

import { FeeId, LosId } from '../../BrandedIds';
import { FeeStatus } from '../../events/CreateChargeEvent';
import { AdvanceConfig } from '../../loan/Charges';
import { InvestorRemittanceSplit } from '../../loan/InvestorRemittanceSplit';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableAdvance = z
  .object({
    type: z.literal('advance'),
    id: zodBrandedUuid<FeeId>(),
    loanId: zodBrandedString<LosId>(),

    totalAmount: z.number(),
    amountRemaining: z.number(),
    status: FeeStatus,
    chargeDate: zodTemporalPlainDate,
    updatedAt: zodTemporalInstant.optional(),
    cancelledAt: zodTemporalInstant.optional(),
    comment: z.string().optional(),
    investorRemittanceSplit: InvestorRemittanceSplit.optional(),
    isDeferred: z.boolean(),
    createdAt: zodTemporalInstant.optional(),

    advanceConfig: AdvanceConfig.optional(),
    recipient: z.string().optional(),
    advanceInterest: z.number().optional(),
    advancePrincipal: z.number().optional(),
    originalPrincipal: z.number().optional(),
    advanceInterestCharged: z.number().optional(),
    advanceInterestUpdatedAt: zodTemporalInstant.optional(),
  })
  .meta({ title: 'Advance' });

export type ExportableAdvance = z.infer<typeof ExportableAdvance>;
